/** @format */

import CreatePasswordFormView from "./CreatePasswordForm.view";
import { FormProps } from "antd/lib/form";
import { ICreatePasswordFormProps } from "./CreatePasswordForm.types";
import { InputProps } from "antd/lib/input";
import { message } from "antd";
import React from "react";
import VoiceGainAuthSvcApi from "../../../apis/VoiceGainAuthSvcApi";

interface IState {
	newPassword?: string;
	retypedNewPassword?: string;
}

class CreatePasswordFormContainer extends React.Component<
	ICreatePasswordFormProps,
	IState
> {
	constructor(props: any) {
		super(props);
		this.state = {};
	}

	public render = () => (
		<CreatePasswordFormView
			disableCreate={this.calculateDisableCreate()}
			newPassword={this.state.newPassword}
			onChangeNewPassword={this.onChangeNewPassword}
			onChangeRetypedNewPassword={this.onChangeRetypedNewPassword}
			onClickCreate={this.onClickCreate}
			retypedNewPassword={this.state.retypedNewPassword}
		/>
	);

	private calculateDisableCreate = (): boolean =>
		!this.checkFormFieldsAreValid();

	private checkFormFieldsAreValid = (): boolean =>
		this.checkNewPasswordIsNotEmpty() &&
		this.checkRetypedNewPasswordIsNotEmpty() &&
		this.checkNewPasswordEqualsRetypedNewPassword();

	private checkNewPasswordEqualsRetypedNewPassword = (): boolean =>
		this.state.newPassword === this.state.retypedNewPassword;

	private checkNewPasswordIsNotEmpty = (): boolean =>
		this.state.newPassword !== undefined && this.state.newPassword !== "";

	private checkRetypedNewPasswordIsNotEmpty = (): boolean =>
		this.state.retypedNewPassword !== undefined &&
		this.state.retypedNewPassword !== "";

	private onChangeNewPassword: InputProps["onChange"] = ({
		target: { value: newPassword },
	}) => this.setState({ newPassword });

	private onChangeRetypedNewPassword: InputProps["onChange"] = ({
		target: { value: retypedNewPassword },
	}) => this.setState({ retypedNewPassword });

	private onClickCreate: FormProps["onFinish"] = (event) => {
		event.preventDefault();
		if (this.state.newPassword && this.checkFormFieldsAreValid()) {
			VoiceGainAuthSvcApi.resetPassword(
				this.state.newPassword,
				this.props.resetToken,
				this.props.uid
			)
				.then((response) => {
					if (response.ok) {
						message.success("Successfully reset password");
						this.props.setFormIsSubmittedToTrue();
					} else {
						throw new Error("Error resetting password");
					}
				})
				.catch((error) => message.error(error.message));
		}
	};
}

export default CreatePasswordFormContainer;
